import { ref } from 'vue'
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal'
import { Collapse } from 'vue-collapsed'
// import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Autoplay, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';
import Swal from 'sweetalert2'

import 'maz-ui/styles' // or import 'maz-ui/css/main.css'
import MazInput from 'maz-ui/components/MazInput'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

export const sharedFunction = {
  components: {
    MazPhoneNumberInput,
    Keyboard,
    Collapse,
    Swiper,
    SwiperSlide,
    VueFinalModal,
    ModalsContainer
  },
  data () {
    return {
      client: null,
      new_client: null,
      order_phone: null,
      order_phone_country_code: null,
      keysForHandleKeyUpClientModal: '',
      orderComments: '',
      shiftPressed: null,
      fontSwall: '3rem',
      bounceCartQuantity: false,
      optionsInSteps: false,
      loader: true,
      countdown: 50,
      email_to_send: '',
      keyForPhone: 0,
      phone_to_send: '',
      countryCode: ref('RO'),
      resultsPhone: ref(),
      infoShown: {
        top: false,
        bottom: false,
        permanentDisabled: false,
      },
      activeFilter: {
        top: false,
        bottom: false,
      },
      activeProductList: {
        top: false,
        bottom: false,
      },
      allLang: window.allLang,
      showSettings: false,
      listOfLangIsOpen: 0,
      topReach: 0,
      bottomReach: 0,
      touchstartX: 0,
      touchstartY: 0,
      touchendX: 0,
      touchendY: 0,
      swiperModule: [Autoplay, EffectFade ],
      swiperModuleTutorial: [Autoplay, EffectFade ],
      swiperTutorial: null,
      qr_code: null,
      checkIfPaymentIsCompleteTimeout: null,
      timeoutRestartFinishOrder: null,
      timeoutCartReload: null,
      activitiDetected: null,
      finishOrderNr: null,
      activeKeyboard: false,
      activeKeyboardClient: false,
      keyboard: null,
      packed: false,
      loading: false,
      isExpended: null,
      orderComent: '',
      packingMethod: null,
      currency_symbol: null,
      selectedCategory: null,
      selectedTopCategory: null,
      showRemoveTextFromSearch: 0,
      top_category: null,
      category: null,
      products: null,
      banners: null,
      splashScreenBanners: [],
      sliderNextTimeout: null,
      nextSplashScreenSlider: 0,
      searchText: '',
      couponText: '',
      couponApplied: false,
      cuiText: '',
      cui: '',
      pagerText: '',
      pager: '',
      onCreatedAfterLoginFlag: false,
      selectedPaymentMethod: '',
      formloadCounter: 0,
      newTextTimeout: null,
      paymentLinkForIframe: '',
      showSplashScreenModal: false,
      showOptionModal: false,
      showOptionModalEffectOut: false,
      showProductModal: false,
      showCartModal: false,
      showPaymentModal: false,
      showClientModal: false,
      showCouponModal: false,
      showPagerModal: false,
      showIframeModal: false,
      showCompleteModal: false,
      showSoldWithModal: false,
      showPosModal: false,
      showCashMachineModal: false,
      showSettingsModal: false,
      showP9Modal: false,
      showCuiModal: false,
      customMsgCashMachine: null,
      showLoaderCompleteCashMachine: false,
      corectPass: false,
      thePass: '',
      insertedMoneyInCashMachine: 0,
      soldWithCategory: null,
      selectedSoldWithProducts: [],
      extraCostSoldWith: 0,
      currentOptionInPopup: null,
      cart: null,
      payMethod: '',
      curentLang: 'ro',
      freePaymentEnabled: false,
      cashPaymentEnabled: false,
      cardPaymentEnabled: false,
      posOnDeliveryPaymentEnabled: false,
      kioskPosOnDeliveryPaymentEnabled: false,
      posPaymentEnabled: false,
      onePaymentAllreadyPicked: false,
      disablePaymentClass: '',
      editToCartUpdateQuantityIsAllready: false,
      selectedTip: null,
      customTip: null,
      swiperOptions: {
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        // initialSlide: this.$f7route.params.initial,
        on: {
          // slideNextTransitionEnd: this.sliderChangedNext,
          // slidePrevTransitionEnd: this.sliderChangedPrev
        }
      },
      // loadingCompleteOrder: false,
      currentProductInPopup: null,
    }
  },
  created () {
    // in onCreatedAfterLogin()
  },
  methods: {
    onCreatedAfterLogin () {
      this.onCreatedAfterLoginFlag = true
      if (this.isUsingCashMachine) {
        if (!this.socket.connected) {
          this.socket.connect()
        }

        this.socket.on('OPEN', (data) => {
          console.log('OPEN')
          console.log(data)
        });    

        this.socket.on('EMPTIED', (data) => {
          console.log('EMPTIED')
          this.loader = false
        });    

        this.socket.on('NOTE_STORED_IN_PAYOUT', (data) => {
          console.log('NOTE_STORED_IN_PAYOUT')
          console.log(data)
        });

        this.socket.on('READ_NOTE', (data) => {
          console.log('READ_NOTE')
          console.log()
          if (data && data.data && data.data.total) {
            this.insertedMoneyInCashMachine = (data.data.total / 100)
          }
        });

        this.socket.on('COMPLETE_ORDER', (data) => {
          console.log('COMPLETE_ORDER')
          console.log(data)
          this.customMsgCashMachine = null
          this.showLoaderCompleteCashMachine = true
          this.completeOrder('cash_machine')
        });

        this.socket.on('TOO_MANY', (data) => {
          this.showCashMachineModal = false
          this.customMsgCashMachine = null
          console.log('TOO_MANY')
          console.log(data)
        });

        this.socket.on('MONEY_BACK', (data) => {
          this.customMsgCashMachine = 'Aparatul nu va poate da rest. Va va da banii inapoi!';
          console.log('MONEY_BACK')
          console.log(data)
        });
      }
    },
    cashMachineEmptyAll () {
      this.loader = true
      this.socket.emit('empty_all')
    },
    cashMachinePay () {
      this.socket.emit('start_pay', null)
    },
    cashMachineStop () {
      this.socket.emit('stop_pay')
    },
    cashMachinePayout () {
      this.socket.emit('payout')
      this.showCashMachineModal = false
      this.customMsgCashMachine = null
      this.onePaymentAllreadyPicked = false
    },
    maskPhoneNumber(phoneNumber) {
      if (phoneNumber) {
        phoneNumber = phoneNumber.toString();
        if (phoneNumber.length >= 3) {
          return phoneNumber.slice(0, -3) + '***';
        } else {
          return '*'.repeat(phoneNumber.length);
        }
      }
    },
    openShowSplashScreenModal () {
      this.showSplashScreenModal = true;
      this.searchText = ''
    },
    onSwiperTutorial (swiper) {
      this.swiperTutorial = swiper
    },
    handleKeyUpClientModal (event) {
      if (event.key === 'Shift') {
        // this.shiftPressed = false;
        this.shiftPressed = true;
        return;
      }
      if (event.key.length === 1) {
        if (this.shiftPressed) {
          this.keysForHandleKeyUpClientModal += event.key.toUpperCase()
        } else {
          this.keysForHandleKeyUpClientModal += event.key
        }
      }
      this.shiftPressed = false;

      if (event.key == 'Enter') {
        console.log(this.keysForHandleKeyUpClientModal)
        let result = this.keysForHandleKeyUpClientModal
        this.keysForHandleKeyUpClientModal = ''

        result = atob(result)
        result = result.split('#')
        let user_id = result[0].substring(1)
        user_id = user_id.slice(0, -2)
        user_id = atob(user_id)
        user_id = JSON.parse(user_id).id
        let timestamp = result[1].slice(0, -1)
        let timestampNow = Math.floor((new Date()).getTime() / 1000)

        if (timestampNow - timestamp <= 600) {
          this.searchForClient(user_id)
        } else {
          this.errorQrScan()
        }
      }
      // event.preventDefault()

      // // Get the pasted data via clipboardData API
      // let clipboardData = event.clipboardData || window.clipboardData;
      // let pastedData = clipboardData.getData('Text');
    },
    removeClient () {
      this.new_client = null
      this.client = null
      this.order_phone = null
      this.order_phone_country_code = null
      this.$nextTick(() => {
        this.$refs.modal_bg.focus()
        // document.querySelector(".clientModal .payment__buttons").focus()
        setTimeout(() => {
          this.$refs.modal_bg.focus()
          // document.querySelector(".clientModal .payment__buttons").focus()
        }, 1000)
      })
    },
    errorQrScan () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.qrError'),
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      });
    },
    searchForClient (user_id = null) {
      if (user_id) {
        var data2 = {
          token: this.token,
          company_id: this.json.company_id,
          from_kiosk: 1,
          search: user_id
        }
        this.apiRequest('/search-by-id', 'GET', data2, (response) => {
          if (response.data.status === true && response.data.data.clients.length) {
              this.client = response.data.data.clients[0]
          } else {
            this.errorQrScan()
          }
        })
      } else {
        if (this.phone_to_send != '') {
          const phoneInput = document.getElementById('phone_to_send');
          if (this.resultsPhone && this.resultsPhone.isValid) {
            this.order_phone = this.resultsPhone.formatNational
            this.order_phone_country_code = this.resultsPhone.countryCallingCode
          } else {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.phoneError'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
            return 0;
          }
          
          var data2 = {
            token: this.token,
            company_id: this.json.company_id,
            from_kiosk: 1,
            search: this.phone_to_send
          }
          this.phone_to_send = ''
          this.keyboard.clearInput()
          this.apiRequest('/search-by-phone', 'GET', data2, (response) => {
            if (response.data.status === true) {
              if (response.data.data.clients.length) {
                this.new_client = false
                this.client = response.data.data.clients[0];
              } else {
                this.client = null
                this.new_client = true
              }
            }
          })
        }
      }
    },
    searchForClientMobile () {
      if (this.resultsPhone && this.resultsPhone.isValid) {
        this.order_phone = this.resultsPhone.formatNational
        this.order_phone_country_code = this.resultsPhone.countryCallingCode
        var data2 = {
          token: this.token,
          company_id: this.json.company_id,
          from_kiosk: 1,
          search: this.phone_to_send
        }
        this.phone_to_send = ''
        this.apiRequest('/search-by-phone', 'GET', data2, (response) => {
          if (response.data.status === true) {
            if (response.data.data.clients.length) {
              this.new_client = false
              this.client = response.data.data.clients[0];
            } else {
              this.client = null
              this.new_client = true
            }
          }
        })
      } else {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        Swal.fire({
          title: this.$t('addOrder.phoneError'),
          target: document.getElementById('swal-template'),
          customClass: {
            container: className,
          }
        });
        return 0;
      }
    },
    openCuiModal () {
      this.cui = ''
      this.clearKeyBoard()
      this.activeKeyboard = true
      this.showCuiModal = true
      this.showPaymentModal = false //ForKeyboard
    },
    changeCui () {
      this.cui = this.cuiText
      this.closeCuiModal()
    },
    closeCuiModal () {
      this.showCuiModal = false
      this.showPaymentModal = true
      this.activeKeyboard = false
      this.keyboard.clearInput()
      this.cuiText = ''
    },
    changePhone () {
      this.phone_to_send = ''
      this.clearKeyBoard()
      this.keyForPhone = 1
      if (this.json.type != 'Kiosk') {
        this.activeKeyboard = true
      }
    },
    getRaport (raportType) {
      this.showSettingsModal = false
      if (raportType == 'X') {
        this.localRequestFiscalNet('/api/Receipt', 'POST', '"X^",', (response) => {
            console.log(response)
        })
        // this.localRequest('/get_X', 'GET', {
        //     'fiscal': JSON.stringify(this.DBfiscal)
        //     }, (response) => {
        //     console.log(response)
        // })
      }
      if (raportType == 'Z') {
        this.localRequestFiscalNet('/api/Receipt', 'POST', '"Z^",', (response) => {
            console.log(response)
        })
        // this.localRequest('/get_Z', 'GET', {
        //     'fiscal': JSON.stringify(this.DBfiscal)
        //     }, (response) => {
        //     console.log(response)
        // })
      }
    },
    verifyPass () {
      if (this.kiosk_pass == this.thePass) {
        this.corectPass = true
      } else {
        this.showSettingsModal = false
      }
      this.clearKeyBoard()
    },
    goToSettings () {
      this.thePass = ''
      this.corectPass = false
      this.showSettingsModal = true
      this.activeKeyboard = true
      // console.log('settings')
    },
    setScroolVars (el, active) {
      // let heightOfEl = document.querySelector(".productList").offsetHeight
      if (el.scrollTop > 120 && document.querySelector(".productList").scrollHeight > window.screen.height) {
        active.top = true
      } else {
        active.top = false
      }
      if (el.scrollHeight - el.offsetHeight <= el.scrollTop + 2) {
        active.bottom = false
      } else {
        active.bottom = true
      }
    },
    handleGesture (touchableElement) {

      // (this.touchstartY - this.touchendY > 50)
      let flagForDetDir = true;
      if (this.json.type != 'Kiosk') {
        if (this.touchstartY > this.touchendY && (this.touchstartY - this.touchendY > 50) ) {
          flagForDetDir = false;
        }
        if (this.touchendY > this.touchstartY && (this.touchendY - this.touchstartY > 50) ) {
          flagForDetDir = false;
        }
      }

      if (this.touchendX < this.touchstartX && (this.touchstartX - this.touchendX > 50) && flagForDetDir && this.json.type != 'Kiosk') {
        // console.log('Swiped Left Go Right');
        this.goNextOrPriv(1)
        // for (var i = this.category.length - 1; i >= 0; i--) {
        //   if (this.category[i].id == this.selectedCategory) {
        //     if (i+1 < this.category.length) {
        //       this.getProducts(this.category[i+1].id, this.selectedTopCategory)
        //     } else {
        //       this.getProducts(this.category[0].id, this.selectedTopCategory)
        //     }
        //     return 0
        //   }
        // } 
      }

      if (this.touchendX > this.touchstartX && (this.touchendX - this.touchstartX > 50) && flagForDetDir && this.json.type != 'Kiosk') {
        // console.log('Swiped Right Go Left');
        this.goNextOrPriv(-1)
        // for (var i = this.category.length - 1; i >= 0; i--) {
        //   if (this.category[i].id == this.selectedCategory) {
        //     if (i-1 >= 0) {
        //       this.getProducts(this.category[i-1].id, this.selectedTopCategory)
        //     } else {
        //       this.getProducts(this.category[this.category.length-1].id, this.selectedTopCategory)
        //     }
        //     return 0
        //   }
        // }
      }

      if (this.touchendY < this.touchstartY && (this.touchstartY - this.touchendY > 50) && this.json.type == 'Kiosk' ) {
          // console.log('Swiped Up Go Down')
          if (touchableElement.scrollHeight - touchableElement.offsetHeight <= touchableElement.scrollTop + 2) {
          // if(touchableElement.scrollTop + touchableElement.offsetHeight == touchableElement.scrollHeight) {
            if (this.bottomReach) {
              this.goNextOrPriv(1)
              if (this.infoShown.bottom == true) {
                this.infoShown.permanentDisabled = true
              }
              // for (var i = this.category.length - 1; i >= 0; i--) {
              //   if (this.category[i].id == this.selectedCategory) {
              //     if (i+1 < this.category.length) {
              //       this.getProducts(this.category[i+1].id, this.selectedTopCategory)
              //       if (this.infoShown.bottom == true) {
              //         this.infoShown.permanentDisabled = true
              //       }
              //       return 0
              //     }
              //   }
              // } 
            }
          }
          // if (touchableElement.offsetHeight - touchableElement.scrollHeight == 0) { // No scrool in page
          //   for (var i = this.category.length - 1; i >= 0; i--) {
          //     if (this.category[i].id == this.selectedCategory) {
          //       if (i+1 < this.category.length) {
          //         this.getProducts(this.category[i+1].id)
          //         return 0
          //       }
          //     }
          //   } 
          // }
      }

      if (this.touchendY > this.touchstartY && (this.touchendY - this.touchstartY > 50) && this.json.type == 'Kiosk' ) {
        // console.log('Swiped Down Go Up');
        if(touchableElement.scrollTop == 0) {
          if (this.topReach) {
            this.goNextOrPriv(-1)
            // for (var i = this.category.length - 1; i >= 0; i--) {
            //   if (this.category[i].id == this.selectedCategory) {
            //     if (i-1 >= 0) {
            //       this.getProducts(this.category[i-1].id, this.selectedTopCategory)
            //       return 0
            //     }
            //   }
            // }
          }
        }
      }

      // if (this.touchendY === this.touchstartY) {
      //     console.log('Tap');
      // }
    },
    goNextOrPriv (number) {
      let allCategories = []
      for (var i = 0; i < this.top_category.length; i++) {
        for (var j = 0; j < this.top_category[i].categories.length; j++) {
          allCategories.push(this.top_category[i].categories[j])
        }
      }
      for (var i = 0; i < this.category.length; i++) {
        allCategories.push(this.category[i])
      }

      // this.selectedCategory
      for (var i = 0; i < allCategories.length; i++) {
        if (allCategories[i].id == this.selectedCategory) {
          if (i+number < 0) {
            this.getProducts(allCategories[allCategories.length-1].id, allCategories[allCategories.length-1].top_category_id)
          } else if (i+number < allCategories.length) {
            this.getProducts(allCategories[i+number].id, allCategories[i+number].top_category_id)
          } else {
            this.getProducts(allCategories[0].id, allCategories[0].top_category_id)
          }
          return 0; // IMPORTANT TO STOP HERE
        }
      }
    },
    goNextOrPriv2 (number) {
      for (var i = this.category.length - 1; i >= 0; i--) {
        if (this.category[i].id == this.selectedCategory) {
          if (i+number < 0) {
            this.getProducts(this.category[this.category.length-1].id, this.selectedTopCategory)
          } else if (i+number < this.category.length) {
            this.getProducts(this.category[i+number].id, this.selectedTopCategory)
          } else {
            this.getProducts(this.category[0].id, this.selectedTopCategory)
          }
          return 0; // IMPORTANT TO STOP HERE
        }
      } 
    },
    detectActivity () {
      clearTimeout(this.activitiDetected)
      if (this.showSplashScreenModal != true && this.packed != false) { // is not alllready in splash
        this.activitiDetected = setTimeout(() => {
          this.restart()
        }, 60000 * 2) // 2 mins
      }
    },
    exitSplashScreen () {
      if (this.json.type == 'Kiosk') {
        this.createCacheForMenu();
        if (this.packing_method) {
          this.packingMethod = this.packing_method;
          this.showSplashScreenModal = false;
          this.packed = false;
        } else {
          this.packed = true;
        }
        this.goFullScreen();
        clearTimeout(this.sliderNextTimeout)
      } else {
        this.showSplashScreenModal = false
      }
    },
    definKeyboard () {
      if (this.keyboard) {
        this.keyboard.destroy()
      }
      this.keyboard = new Keyboard(".simple-keyboard", {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        mergeDisplay: true,
        layoutName: this.showClientModal ? "phone" : "default",
        layout: {
          default: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m {backspace}",
            "{space} {ent}"
          ],
          shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shift} Z X C V B N M {backspace}",
            "{space} {ent}"
          ],
          phone: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "+ 0 {backspace}",
            "{ent}",
          ],
        },
        display: {
          "{space}": "space",
          "{numbers}": "123",
          "{ent}": "enter",
          "{escape}": "esc ⎋",
          "{tab}": "tab ⇥",
          "{backspace}": "⌫",
          "{capslock}": "caps lock ⇪",
          "{shift}": "⇧",
          "{controlleft}": "ctrl ⌃",
          "{controlright}": "ctrl ⌃",
          "{altleft}": "alt ⌥",
          "{altright}": "alt ⌥",
          "{metaleft}": "cmd ⌘",
          "{metaright}": "cmd ⌘",
          "{abc}": "ABC"
        }
      });
    },
    definKeyboardClient () {
      if (this.keyboard) {
        this.keyboard.destroy()
      }
      this.keyboard = new Keyboard(".simple-keyboard-client", {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        mergeDisplay: true,
        layoutName: this.showClientModal ? "phone" : "default",
        layout: {
          default: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l",
            "{shift} z x c v b n m {backspace}",
            "{space} {ent}"
          ],
          shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "Q W E R T Y U I O P",
            "A S D F G H J K L",
            "{shift} Z X C V B N M {backspace}",
            "{space} {ent}"
          ],
          phone: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "+ 0 {backspace}"
            // "{ent}",
          ],
        },
        display: {
          "{space}": "space",
          "{numbers}": "123",
          "{ent}": "enter",
          "{escape}": "esc ⎋",
          "{tab}": "tab ⇥",
          "{backspace}": "⌫",
          "{capslock}": "caps lock ⇪",
          "{shift}": "⇧",
          "{controlleft}": "ctrl ⌃",
          "{controlright}": "ctrl ⌃",
          "{altleft}": "alt ⌥",
          "{altright}": "alt ⌥",
          "{metaleft}": "cmd ⌘",
          "{metaright}": "cmd ⌘",
          "{abc}": "ABC"
        }
      });
    },
    onChange (input) {
      let enterInOne = false
      if (this.showCouponModal) {
        this.couponText = input
        enterInOne = true
      }
      if (this.showClientModal) {
        this.phone_to_send = input
        enterInOne = true
        // this.$nextTick(() => {
        //   if (this.$refs["clientPhoneField"]) this.$refs["clientPhoneField"].focus()
        //   setTimeout(() => {
        //     if (this.$refs["clientPhoneField"]) this.$refs["clientPhoneField"].focus()
        //   }, 500)
        // })
      }
      if (this.showCuiModal) {
        this.cuiText = input
        enterInOne = true
        this.$nextTick(() => {
          if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 500)
        })
      }
      if (this.showPagerModal) {
        this.pagerText = input
        enterInOne = true
        this.$nextTick(() => {
          if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 500)
        })
      }
      if (this.showProductModal) {
        this.currentProductInPopup.additional_info = input
        enterInOne = true
      }
      if (this.showSettingsModal) {
        this.thePass = input
        enterInOne = true
      }
      if (this.showPaymentModal) {
        // if (this.keyForPhone) {
          this.phone_to_send = input
        // } else {
        //   this.cui = input
        // }
        
        enterInOne = true
      }
      if (!enterInOne) {
        this.searchText = input
      }
      // this.keyboard.input.default = this.searchText
      // this.newText()
    },
    onKeyPress (button) {
      if (button === "{ent}") {
        let enterInOne = false
        if (this.showClientModal) {
          this.searchForClient()
          return 0;
        }
        if (this.showCuiModal) {
          enterInOne = true
          this.changeCui()
        }
        if (this.showCouponModal) {
          enterInOne = true
          this.applyCoupon(1)
        }
        if (this.showPagerModal) {
          enterInOne = true
          this.applyPager()
        }
        if (this.showProductModal) {
          enterInOne = true
          //silence
        }
        if (this.showSettingsModal) {
          this.verifyPass()
          enterInOne = true
        }
        if (this.showPaymentModal) {
          enterInOne = true
          //silence
        }
        if (!enterInOne) {
          this.newText()
        }
        setTimeout( ()=> {
          this.activeKeyboard = false;
        }, 200);
      }
      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    },
    clearKeyBoard () {
      this.keyForPhone = 0
      if (this.keyboard) {
        // this.searchFilterShow = false
        this.showRemoveTextFromSearch = 0
        this.activeKeyboard = false
        this.keyboard.clearInput(this.$refs.searchText)
        this.keyboard.clearInput()
      }
      if (this.json.type == 'Kiosk') {
        this.searchText = ''
      }
    },
    openListOfLang () {
      this.listOfLangIsOpen = !this.listOfLangIsOpen
    },
    changeLanguageLocal (lng, noList = false) {
      // if (this.top_category && this.curentLang != lng) {
      //   for (var i = this.top_category.length - 1; i >= 0; i--) {
      //     if (this.top_category[i].name.toLowerCase() == lng.toLowerCase()) {
      //       this.getProducts (null, this.top_category[i].id)
      //       break;
      //     }
      //   }
      // }
      this.curentLang = this.changeLanguage(lng)
      if (!noList) {
        this.openListOfLang()
      }
    },
    updateCategories (opId = null, valId = null) {
      var sumToBeAdded = 0

      if (this.currentProductInPopup.product_options.length) {
        for (var i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
          this.currentProductInPopup.product_options[i].optionsSelected = []
          if (this.currentProductInPopup.product_options[i].values.length) {
            for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
              if (this.currentProductInPopup.product_options[i].type === 'radio') {
                if (this.currentProductInPopup.product_options[i].checked === this.currentProductInPopup.product_options[i].values[j].id) {
                  sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price)
                  this.currentProductInPopup.product_options[i].optionsSelected[0] = this.currentProductInPopup.product_options[i].values[j].id
                  this.currentProductInPopup.product_options[i].values[j].checked = true
                } else {
                  this.currentProductInPopup.product_options[i].values[j].checked = false
                }
              }
              if (this.currentProductInPopup.product_options[i].type === 'checkbox' && this.currentProductInPopup.product_options[i].values[j].checked) {
                sumToBeAdded += parseFloat(this.currentProductInPopup.product_options[i].values[j].price)
              }
              if (this.currentProductInPopup.product_options[i].type === 'checkbox') {

                if (
                    opId && 
                    valId && 
                    this.currentProductInPopup.product_options[i].max_no == 1 && 
                    this.currentProductInPopup.product_options[i].min_no == 1
                ) {
                    if (opId == this.currentProductInPopup.product_options[i].id && valId != this.currentProductInPopup.product_options[i].values[j].id) {
                      this.currentProductInPopup.product_options[i].values[j].checked = false;
                    } else {
                      if (this.currentProductInPopup.product_options[i].values[j].checked) {
                        this.currentProductInPopup.product_options[i].optionsSelected = [];
                        this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                      }
                    }
                } else {
                  if (this.currentProductInPopup.product_options[i].values[j].checked) {
                    this.currentProductInPopup.product_options[i].optionsSelected.push(this.currentProductInPopup.product_options[i].values[j].id)
                  }
                }
              }
              if (this.currentProductInPopup.product_options[i].values[j].checked) {
                this.currentProductInPopup.product_options[i].values[j].checked = true
              } else {
                this.currentProductInPopup.product_options[i].values[j].checked = false
              }
            }
          }
        }
      }
      this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price) * parseFloat(this.currentProductInPopup.quantity)
      this.currentProductInPopup.price_details.price = this.currentProductInPopup.price_details.price + (parseFloat(sumToBeAdded) * parseFloat(this.currentProductInPopup.quantity))
      this.currentProductInPopup.price_details.price = parseFloat(this.currentProductInPopup.price_details.price).toFixed(2)

      let verifyCart = 1
      if (this.currentProductInPopup.product_options.length) {
        for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
          if (this.currentProductInPopup.product_options[i].required) {
            if (!this.currentProductInPopup.product_options[i].optionsSelected.length) {
              verifyCart = 0
            }
          }
          if (this.currentProductInPopup.product_options[i].min_no) {
            if (
                !(parseInt(this.currentProductInPopup.product_options[i].min_no) <= this.currentProductInPopup.product_options[i].optionsSelected.length)
                ) {
              verifyCart = 0
            }
          }
          if (this.currentProductInPopup.product_options[i].max_no) {
            if (!(parseInt(this.currentProductInPopup.product_options[i].max_no) > this.currentProductInPopup.product_options[i].optionsSelected.length)) {
              // verifyCart = 0
              // DISABLE all rest
              // if (
              //   this.currentProductInPopup.product_options[i].max_no == 1 &&
              //   this.currentProductInPopup.product_options[i].min_no == 1
              //   ) {
              //   //HERE
              // } else {
                for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                  if (this.currentProductInPopup.product_options[i].values[j].checked) {
                    this.currentProductInPopup.product_options[i].values[j].disabled = false
                  } else {
                    if (this.currentProductInPopup.product_options[i].max_no != 1 && this.currentProductInPopup.product_options[i].min_no != 1) {
                      this.currentProductInPopup.product_options[i].values[j].disabled = true;
                    }
                  }
                }
              // }
            } else {
              for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                this.currentProductInPopup.product_options[i].values[j].disabled = false
              }
            }
          }
        }
      }
      
      let prod = this.currentProductInPopup
      this.currentProductInPopup = null
      this.currentProductInPopup = prod

      if (verifyCart) {
        this.addToCartDisabled = false
      } else {
        this.addToCartDisabled = true
      }
    },
    modificationsInCart () {
      this.customTip = (this.cart.tip_value && this.cart.tip_value > 0) ? this.cart.tip_value : ''
      if (this.cart.myCart.products_count <= 0) {
        this.showCartModal = false
      }
      if (this.cart.myCart.total_cart_price <= 0) {
        this.payMethod = 'free'
      } else if (this.payMethod === 'free') {
        if (this.cashIsAvailable) {
          this.payMethod = 'cash'
        } else {
          this.payMethod = ''
        }
      }
    },
    showCart () {
      // this.loader = true
      this.searchText = ''
      this.getTheCart( ()=> {
        // this.loader = false
        this.showProductModal = false;
        this.showCartModal = true;
      })
    },
    addToCart () {
      if (this.soldWithCategory && this.soldWithCategory.length) {
        this.showSoldWithModal = true
      }
      this.currentProductInPopup.categories = this.currentProductInPopup.product_options
      // this.currentProductInPopup.categories.optionsSelected = this.currentProductInPopup.product_options
      for (var i = this.currentProductInPopup.categories.length - 1; i >= 0; i--) {
        this.currentProductInPopup.categories[i].options = this.currentProductInPopup.product_options[i].values
        for (var j = this.currentProductInPopup.categories[i].options.length - 1; j >= 0; j--) {
          this.currentProductInPopup.categories[i].options[j].name = this.currentProductInPopup.categories[i].options[j].name
        }
      }
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        action: 'add',
        add_order: true,
        product: this.currentProductInPopup
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          // this.soldWith(this.currentProductInPopup.id)
          this.cart = response.data.data
          this.bounceCartQuantity = true
          setTimeout(()=>{
            this.bounceCartQuantity = false
          }, 2000)
          this.modificationsInCart()
          // Afișarea notificării
          if(this.json.type != 'Kiosk') {
            this.showNotification(this.$t('addOrder.addToCart'))
          }
        } else {
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
          if (response.data.errors.hasOwnProperty('shopping_cart_id')) {
            this.restart()
          }
        }
      })
      this.showOptionModal = false
      this.showProductModal = false
    },
    showNotification(message) {
      const notification = document.createElement('div');
      notification.className = 'notification';
      notification.innerText = message;
      document.body.appendChild(notification);
      setTimeout(() => {
          notification.classList.add('fade-out');
          setTimeout(() => {
              document.body.removeChild(notification);
          }, 500);
      }, 3000);
    },
    soldWith (productId) {
      this.closeSoldWithPopup()
      var data2 = {
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        with_cache: true
      }
      this.apiRequest('/product-sold-with/' + productId , 'GET', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.soldWithCategory = response.data.data
          // if (response.data.data.length) {
          //   this.showSoldWithModal = true
          // }
        }
      })
    },
    selectSoldWithProduct (prod) {
      if (prod.active) {
        prod.active = 0
        this.selectedSoldWithProducts = this.selectedSoldWithProducts.filter(el => el.id != prod.id);
      } else {
        prod.active = 1
        this.selectedSoldWithProducts.push(prod)
      }
      this.extraCostSoldWith = this.selectedSoldWithProducts.reduce((accumulator, object) => {
        return accumulator + object.price;
      }, 0)
      this.extraCostSoldWith = parseFloat(this.extraCostSoldWith).toFixed(2)
    },
    closeSoldWithPopup () {
      this.showSoldWithModal = false
      this.soldWithCategory = null
      this.extraCostSoldWith = 0
      this.selectedSoldWithProducts = []
    },
    addTOCartExtra () {
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        action: 'add_multiple',
        add_order: true,
        products: this.selectedSoldWithProducts
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
          this.closeSoldWithPopup()

          // Afișarea notificării
          if(this.json.type != 'Kiosk') {
            this.showNotification(this.$t('addOrder.addToCart'))
          }
        } else {
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
        }
      })
    },
    nextOptionToCart ($goPrev, $first) {
      if ($first) {
        this.currentOptionInPopup = null
      }

      if (this.currentOptionInPopup === null) {
        this.currentOptionInPopup = this.currentProductInPopup.product_options[0]
        this.currentOptionInPopup.is_the_last_option = false
        this.showProductModal = false
        setTimeout(() => {
          this.showOptionModal = true
        }, 100)
        if (this.currentProductInPopup.product_options.length === 1) {
          this.currentOptionInPopup.is_the_last_option = true
        }
        return 0;
      }

      for (var i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
        if (this.currentOptionInPopup && this.currentOptionInPopup.id === this.currentProductInPopup.product_options[i].id) {
          if ($goPrev) {
            if (i > 0) {
              this.fakeEfectForOptionModal(() => {
                this.currentOptionInPopup = this.currentProductInPopup.product_options[i-1]
                this.currentOptionInPopup.is_the_last_option = false
              })
              break;
            } else {
              this.showProductModal = true
              this.showOptionModal = false
              break;
            }
          } else {
            // go next
            this.fakeEfectForOptionModal(() => {
              this.currentOptionInPopup = this.currentProductInPopup.product_options[i+1]
              this.currentOptionInPopup.is_the_last_option = false
              if (i+1 >= this.currentProductInPopup.product_options.length - 1) {
                this.currentOptionInPopup.is_the_last_option = true
              }
            })
            break;
          }
        }
      }
      return 0;
    },
    fakeEfectForOptionModal(callback) {
      this.showOptionModalEffectOut = true
      setTimeout(() => {
        if (callback) {
          callback()
        }
        setTimeout(() => {
          this.showOptionModalEffectOut = false
        }, 200)
      }, 200)
      
      // this.showOptionModal = false
      // setTimeout(() => {
      //   this.showOptionModal = true
      // }, 300)
    },
    verifyIfOptionIsDisabled () {
      if (this.currentOptionInPopup.required || this.currentOptionInPopup.min_no >=1) {
        if (this.currentOptionInPopup.optionsSelected && this.currentOptionInPopup.optionsSelected.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    editToCart () {
      this.currentProductInPopup.categories = this.currentProductInPopup.product_options
      // this.currentProductInPopup.categories.optionsSelected = this.currentProductInPopup.product_options
      for (var i = this.currentProductInPopup.categories.length - 1; i >= 0; i--) {
        this.currentProductInPopup.categories[i].options = this.currentProductInPopup.product_options[i].values
        for (var j = this.currentProductInPopup.categories[i].options.length - 1; j >= 0; j--) {
          this.currentProductInPopup.categories[i].options[j].name = this.currentProductInPopup.categories[i].options[j].name
        }
      }
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        product_cart_index: this.currentProductInPopup.index,
        action: 'edit',
        add_order: true,
        products_need_deleted: true,
        product: this.currentProductInPopup
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
        } else {
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
        }
      })
      // this.$modal.hide('productModal')
      this.showOptionModal = false
      this.showProductModal = false
    },
    getTheCart (callback = null) {
      var data = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: this.shopping_cart_id,
        location: this.json.location_token,
        method: 'self_ordering'
      }
      this.apiRequest('/get-cart', 'GET', data, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data.data.status != 'DRAFT' && response.data.data.status != 'OPEN_DRAFT') {
            this.restart()
            return 0;
          }
          this.cart = response.data.data
          this.customTip = (this.cart.tip_value && this.cart.tip_value > 0) ? this.cart.tip_value : ''

          if (this.json.type != 'Kiosk') {
            clearTimeout(this.timeoutCartReload)
            this.timeoutCartReload = setTimeout(()=>{
              this.getTheCart()
            }, 30000) // 30sec
          }

          if (callback) {
            callback()
          }
        } else {
          // this.restart()
        }
      })
    },
    getPaymentProfile () {
      var data = {
        token: this.token,
        use_pos: true,
        company_id: this.json.company_id,
        shopping_cart_id: this.shopping_cart_id,
      }
      this.apiRequest('/paymentprofile', 'GET', data, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cardPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'card').length
          this.cashPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'cash').length
          this.posOnDeliveryPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'pos').length
          this.kioskPosOnDeliveryPaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'kiosk_pos').length
          this.freePaymentEnabled = !!response.data.data.payment_options.filter(opt => opt.id === 'free').length
        }
      })
    },
    editToCartUpdateQuantity (quantity, productId, productIndex) {
      if (!this.editToCartUpdateQuantityIsAllready) {
        var data2 = {
          token: this.token,
          fingerprint: this.fingerprint,
          company_id: this.json.company_id,
          action: 'update_quantity',
          add_order: true,
          shopping_cart_id: this.cart.shopping_cart_id,
          quantity: quantity,
          product_id: productId,
          product_index: productIndex,
          products_need_deleted: true
        }
        if (quantity >= 1) {
          this.apiRequest('/update-cart', 'PUT', data2, (response) => {
            if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
              // this.getTheCart()
              this.cart = response.data.data
              // Object.assign(this.cart, response.data.data)
              this.modificationsInCart()
            } else {
              if (response.data.errors.hasOwnProperty('freeze_order')) {
                let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
                Swal.fire({
                  title: this.$t('addOrder.order_id_freeze'),
                  target: document.getElementById('swal-template'),
                  customClass: {
                    container: className,
                  }
                });
              }
            }
            this.editToCartUpdateQuantityIsAllready = false
          })
        }
      }
      this.editToCartUpdateQuantityIsAllready = true
    },
    updateQuantity (prod, add) {
      if (prod.quantity >= 1) {
        if (add) {
          prod.quantity++
        } else {
          if (prod.quantity > 1) {
            prod.quantity--
          }
        }
      }
      this.updateCategories()
    },
    modifyProduct (prod) {
      this.openProduct(prod, true)
    },
    deleteProduct (prodId, index) {
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id,
        action: 'remove_product',
        add_order: true,
        product_id: prodId,
        product_index: index,
        products_need_deleted: true
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
        } else {
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
        }
      })
    },
    emptyCartWithQuestion () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.emptyCart'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: true,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.emptyCart(false)
        }
      })
    },
    emptyCart (withTableUsers = false) {
      if (this.cart && this.cart.status == 'OPEN_DRAFT') {
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        Swal.fire({
              title: this.$t('addOrder.errorRelogin'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            }).then( (result) => {
          // window.location.href = "https://www.taptasty.com/";
          this.restart()
          return 0;
        })
        return 0;
      }
      let cartId = null;
      if (this.cart) {
        cartId = this.cart.shopping_cart_id;
      } else {
        cartId = this.shopping_cart_id;
      }
      var data2 = {
        token: this.token,
        fingerprint: this.fingerprint,
        company_id: this.json.company_id,
        shopping_cart_id: cartId,
        action: 'empty_order',
        add_order: true,
        withTableUsers: withTableUsers,
        table_id: this.json.id,
        products_need_deleted: true
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
        } else {
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
        }
      })
    },
    getBanner () {
      this.loading = true
      this.banners = []
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        location_id: this.json.location_token,
        delivery_method: 'self_ordering'
      }
      this.apiRequest('/banner', 'GET', data2, (response) => {
        if (response.data.status === true) {
          this.splashScreenBanners = []
          for (var i = response.data.data.length - 1; i >= 0; i--) {
            if (response.data.data[i].image_banner && 
              response.data.data[i].image_banner != '' &&
              response.data.data[i].image_banner.indexOf('placeholder') <= -1
              ) {
              this.banners.push(response.data.data[i])
            }
            if (response.data.data[i].image_landing && 
              response.data.data[i].image_landing != '' &&
              response.data.data[i].image_landing.indexOf('placeholder') <= -1
              ) {
              this.splashScreenBanners.push(response.data.data[i])
            }
          }

          if (this.showSplashScreenModal && this.splashScreenBanners.length) {
            this.timeoutSplashScreenBanners()
          }
          this.loading = false
        }
      })
    },
    timeoutSplashScreenBanners () {
      clearTimeout(this.sliderNextTimeout);
      if (this.showSplashScreenModal && this.splashScreenBanners.length) {
        this.sliderNextTimeout = setTimeout(() => {
          if (this.nextSplashScreenSlider < (this.splashScreenBanners.length - 1)) {
            this.nextSplashScreenSlider++;
          } else {
            this.nextSplashScreenSlider = 0;
          }
          this.timeoutSplashScreenBanners()
        }, 10000 )
      }
    },
    getTop (top) {
      this.getProducts(top.categories[0].id, top.id)
      this.searchText = ''
    },
    getProducts (categoryID = null, topCategoryID = null, search = null, aiProducts = null, callback = null, forCacheOnly = null) {
      let timeoutLoading = null
      let selectedTopCategoryIsDifferent = false
      if (!this.kiosk_is_using_top_category) {
        topCategoryID = null
      }
      if (!forCacheOnly) {
        this.selectedCategory = categoryID
        if (this.selectedTopCategory != topCategoryID) {
          this.selectedTopCategory = topCategoryID
          selectedTopCategoryIsDifferent = true
        }
        timeoutLoading = setTimeout(() => {
          this.loading = true
        }, 300)
      }
      var data2 = {
        company_id: this.json.company_id,
        location_id: this.json.location_token,
        delivery_method: 'self_ordering',
        with_top_category: 0,
        with_cache: true
      }
      if (categoryID) {
        data2.category_id = categoryID
      }
      if (topCategoryID) {
        data2.selected_top_category = topCategoryID
      }
      if (search) {
        data2.search = search
      } else {
        this.clearKeyBoard()
        this.searchText = ''
      }
      if (aiProducts) {
        data2.ai_products = aiProducts
      }

      let reqLink = '/admin-order-products'
      if (this.kiosk_is_using_top_category) {
        reqLink = '/kiosk-order-products'
        data2.with_top_category = 1
      }
      this.apiRequest(reqLink, 'GET', data2, (response) => {
        if (response.data.status === true && !forCacheOnly) {
          this.category = response.data.data.categories
          this.products = response.data.data.products
          this.top_category = response.data.data.top_category
          if (response.data.data.products.length) {
            this.currency_symbol = response.data.data.products[0].price_details.currency_symbol
          }
          if (!categoryID && !search && this.category.length) {
            if (this.top_category.length) {
              this.selectedTopCategory = this.top_category[0].id
              this.selectedCategory = this.top_category[0].categories[0].id
            } else {
              this.selectedCategory = this.category[0].id
            }
          }

          this.scroolTopCategory(categoryID, selectedTopCategoryIsDifferent)
          this.scroolTopProducts()
          this.setScroolVars(document.querySelector(".productList"), this.activeProductList)
          clearTimeout(timeoutLoading)
          this.loading = false
        }
        if (callback) callback(response)

        if (!forCacheOnly && !response.requestFromCache) {
          this.openAllProducts(response.data.data.products)
        }
        
      })
    },
    redirectFromImage (slider) {
      if (slider.link_type == 'product' ) {
        this.openProduct({
          'id': slider.link_id
        }, null)
      } else if (slider.link_type == 'category') { 
        this.scroolTopCategory(slider.link_id, true)
        this.scroolTopProducts()
        this.getProducts(slider.link_id)
      } else if (slider.link_type == 'page') { 
        // Do nothing
      } else {
        // Do nothing
      }
    },
    scroolTopCategory (catId, selectedTopCategoryIsDifferent) {
      // let allCategories = []
      // for (var i = 0; i < this.top_category.length; i++) {
      //   for (var j = 0; j < this.top_category[i].categories.length; j++) {
      //     allCategories.push(this.top_category[i].categories[j])
      //   }
      // }
      // for (var i = 0; i < this.category.length; i++) {
      //   allCategories.push(this.category[i])
      // }
      // if (this.allCategories.filter(el => el.id == catId)[0].top_category_id) {

      // }
      if (!this.selectedTopCategory) {
        const categoryDiv = document.getElementsByClassName("filter__cat")[0]
        let thisCategory = document.querySelector('.filter__cat > a')
        if (this.json.type == 'Kiosk') {
          if (catId) {
            thisCategory = document.getElementsByClassName('' + catId)[0]
          }
          if (thisCategory) {
            categoryDiv.scrollTo({ top: thisCategory.offsetTop - 90, behavior: 'smooth'});
          }
        } else {
          if (catId) {
            thisCategory = document.getElementsByClassName('' + catId)[0]
          }
          if (thisCategory) {
            categoryDiv.scrollTo({ left: thisCategory.offsetLeft - categoryDiv.offsetWidth/2 + thisCategory.offsetWidth/2, behavior: 'smooth'});
          }
        }
      } else {
        //TopCat
        const topCategoryDiv = document.getElementsByClassName("filter__cat")[0]
        let thisTopCategory = document.querySelector('.filter__cat > .topGroup')
        
        if (this.json.type == 'Kiosk') {
          thisTopCategory = document.getElementsByClassName('' + this.selectedTopCategory)[0]
          if (thisTopCategory) {
            setTimeout(()=>{
              topCategoryDiv.scrollTo({ top: thisTopCategory.offsetTop - 90, behavior: 'smooth'});
            }, 100) // wait for prev TopCat to close up and curent TopCat to open
          }
        } else if (selectedTopCategoryIsDifferent) {
          thisTopCategory = document.getElementsByClassName('' + this.selectedTopCategory)[0]
          if (thisTopCategory) {
            topCategoryDiv.scrollTo({ left: thisTopCategory.offsetLeft - topCategoryDiv.offsetWidth/2 + thisTopCategory.offsetWidth/2, behavior: 'smooth'});
          }
        }

        //catWithTopCat
        if (this.json.type == 'Kiosk') {
          // No need for this design
          // const categoryDiv = document.querySelector(".filter .filter__cat")
          // let thisCategory = document.querySelector('.filter .filter__cat > a')
          // if (catId) {
          //   thisCategory = document.getElementsByClassName('' + catId)[0]
          // }
          // if (thisCategory) {
          //   categoryDiv.scrollTo({ top: thisCategory.offsetTop - 90, behavior: 'smooth'});
          // }
        } else {
          setTimeout(()=>{
            const categoryDiv = document.querySelector(".filter2 .filter__cat")
            let thisCategory = document.querySelector('.filter2 .filter__cat > a')
            if (catId) {
              thisCategory = document.getElementsByClassName('' + catId)[0]
            }
            if (thisCategory && categoryDiv) {
              categoryDiv.scrollTo({ left: thisCategory.offsetLeft - categoryDiv.offsetWidth/2 + thisCategory.offsetWidth/2, behavior: 'smooth'});
            }
          }, 10)
        }
      }
    },
    scroolTopProducts () {
      const container = document.getElementsByClassName("productList")[0]
      container.scrollTo({ top: 0, behavior: 'smooth'});
    },
    onSwipeTop () {
      // console.log('asd');
    },
    openPagerModal () {
      if (this.json.type == 'Kiosk') {
        this.showPagerModal = true
        this.showPaymentModal = false
        this.activeKeyboard = true
        this.keyboard.clearInput()
        this.pagerText = ''
        this.$nextTick(() => {
          if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 500)
          setTimeout(() => {
            if (this.$refs["pagerInput"]) this.$refs["pagerInput"].focus()
          }, 1000)
        })
      }
    },
    closePagerModal () {
      this.showPagerModal = false
      this.showPaymentModal = true
      this.activeKeyboard = false
      this.keyboard.clearInput()
      this.pagerText = ''
    },
    applyPager () {
      this.pager = this.pagerText
      this.closePagerModal()
      if (this.pager != '') {
        this.disablePaymentClass = '';
      } else {
        this.disablePaymentClass = 'disabled';
      }
    },
    showCoupon () {
      if (this.json.type == 'Kiosk') {
        this.showCouponModal = true
        this.activeKeyboard = true
        this.keyboard.clearInput()
        this.couponText = ''  
      } else {
        this.showCouponModal = true
        this.couponText = ''
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs["couponCode"]) this.$refs["couponCode"].focus()
        }, 500)
      })
    },
    closeCouponModal () {
      if (this.json.type == 'Kiosk') {
        this.showCouponModal = false
        this.activeKeyboard = false
        this.keyboard.clearInput()
        this.couponText = ''
      }
    },
    toggleCoupon() {
      if (this.couponApplied) {
        this.couponText = '';
        this.applyCoupon(false);
      } else if (this.couponText.trim()) {
        this.applyCoupon(true);
      }
    },
    applyCoupon (apply) {
      if (apply) {
        this.applyCouponRequest(this.couponText, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.couponApplied = true;
          }
          if (response.data.errors.wrong_coupon) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.errorPopupCoupon'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
          if (response.data.errors.hasOwnProperty('freeze_order')) {
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            Swal.fire({
              title: this.$t('addOrder.order_id_freeze'),
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            });
          }
          this.showCouponModal = false
          if(this.json.type == 'Kiosk') {
            this.couponText = ''
            this.keyboard.clearInput()
          }
        })
      } else {
        this.applyCouponRequest('', (response) => { // remove coupon
          if (response.data.status === true) {
            this.cart = response.data.data
            this.modificationsInCart()
            this.couponApplied = false;
            this.couponText = '';
          } else {
            if (response.data.errors.hasOwnProperty('freeze_order')) {
              let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
              Swal.fire({
                title: this.$t('addOrder.order_id_freeze'),
                target: document.getElementById('swal-template'),
                customClass: {
                  container: className,
                }
              });
            }
          }
        })
      }
    },
    applyCouponRequest (couponText = '', callback) {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'use_coupon',
        add_order: true,
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (couponText != '') {
        data.apply_coupon = true
        data.status = true
        data.coupon = couponText
        data.check_coupon= 'check_coupon'
      } else {
        data.apply_coupon = false
        data.status = false
        data.coupon = ''
      }
      this.apiRequest('/update-cart', 'PUT', data, (response) => {
        if(callback) callback(response);
      })
    },
    addOrRemoveTipRequest (tip_value = 0, callback) {
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'set_tip',
        add_order: true,
        tip_value: tip_value || 0,
        products_need_deleted: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (callback) {
          callback(response)
        }
      })
    },
    addOrRemoveTip (flag, directToPayment = false) {
      if (flag) {
        Swal.fire({
          title: this.$t('addOrder.titlePopupTip'),
          input: 'number',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: this.$t('addOrder.btnPopup'),
          showLoaderOnConfirm: true,
          target: document.getElementById('swal-template'),
          preConfirm: (val) => {
            this.addOrRemoveTipRequest(val, (response) => {
              if (response.data.status === true) {
                this.cart = response.data.data
                this.modificationsInCart()
                Swal.close()
                if (directToPayment) {
                  this.payNew()
                }
              }
              Swal.hideLoading()
            })
          }
          // allowOutsideClick: () => !swal.isLoading()
        })
      } else {
        this.addOrRemoveTipRequest(0, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data;
            this.modificationsInCart();
            this.selectedTip = null;
          }
        })
      }
    },
    addOrRemoveCustomTip() {
      if (this.customTip !== '') {
        const existingTip = this.cart.order_totals.find(({ name }) => name === 'Tip')?.value || '';
        if (parseFloat(this.customTip) === parseFloat(existingTip)) {
          this.removeCustomTip();
        } else {
          this.addCustomTip();
        }
      }
    },
    addCustomTip() {
      const tipValue = parseFloat(this.customTip);
      console.log(tipValue);
      this.addOrRemoveTipRequest(tipValue, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.selectedTip = null; // Clear selected tip if a custom tip is added
        }
      });
    },
    removeCustomTip() {
      this.addOrRemoveTipRequest(0, (response) => {
        if (response.data.status === true) {
          this.cart = response.data.data;
          this.modificationsInCart();
          this.customTip = '';
          this.selectedTip = null; // Clear selected tip
        }
      });
    },
    addTipDirect(percentage) {
      if (this.selectedTip === percentage) {
        // Deselect if the same tip is clicked again
        this.addOrRemoveTipRequest(0, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data;
            this.modificationsInCart();
            this.selectedTip = null; // Reset selected tip
            this.customTip = ''; // Clear custom tip input
          }
        });
      } else {
        const totalAmount = this.cart.myCart.total_cart_price;
        const tipValue = totalAmount * (percentage / 100);
    
        this.addOrRemoveTipRequest(tipValue, (response) => {
          if (response.data.status === true) {
            this.cart = response.data.data;
            this.modificationsInCart();
            this.selectedTip = percentage;
            this.customTip = ''; // Clear custom tip input
          }
        });
      }
    },
    newText () {
      if (this.searchText.length >= 1) {
        this.showRemoveTextFromSearch = 1
      } else {
        this.showRemoveTextFromSearch = 0
      }
      this.getProducts(null, null, this.searchText)
    },
    deleteTextFromSearch () {
      this.clearKeyBoard()
      this.getProducts()
      this.showRemoveTextFromSearch = 0;
    },
    deleteTextFromSearchMobile () {
      this.getProducts()
      this.showRemoveTextFromSearch = 0;
      this.searchText = ''
    },
    addProductDirectlyToCart (prod) {
      if (prod.has_product_options) {
        this.openProduct(prod, 0, 0, () => {
          // this.addToCart();
        });
      } else {
        this.openProduct(prod, 0, 1, () => {
          this.addToCart();
        });
      }
    },
    openProduct (prod, edit = null, noModal = null, callback = null, forCacheOnly = null) { // noModal infinite loop if true
      let timeoutLoading = null;
      // if (this.json.company_id == 39 && !prod.product_options.length && !noModal) { // noModal for not infinite loop
      //   this.addProductDirectlyToCart(prod)
      //   return 0;
      // }
      if (!forCacheOnly) {
        timeoutLoading = setTimeout(() => {
          this.loading = true
        }, 300)
      }
      this.clearKeyBoard()
      this.searchText = ''
      var i = 0
      var data2 = {
        company_id: this.json.company_id
      }
      // let domProdElement = this.$refs['product' + prod.id]
      // if (domProdElement && domProdElement.length) {
      //   domProdElement = domProdElement[0]
      //   domProdElement.classList.add("pressed");
      //   setTimeout(() => {
      //     domProdElement.classList.remove("pressed");
      //   }, 1000) // 2 sec
      // }
      if (edit) {
        data2.add_order = true
        data2.index = prod.index
        data2.shopping_cart_id = this.cart.shopping_cart_id
      } else {
        data2.not_customer = true
        data2.with_cache = true
      }

      this.optionsInSteps = false
      this.apiRequest('product/' + prod.id, 'GET', data2, (resp) => {
        if (!forCacheOnly) {
          this.addToCartDisabled = false
          clearTimeout(timeoutLoading);
          this.loading = false
          this.currentProductInPopup = resp.data.data[0]
          if (this.currentProductInPopup.product_options_completed) {
            this.currentProductInPopup.product_options = this.currentProductInPopup.product_options_completed
          }
          if (edit) {
            this.currentProductInPopup.index = prod.index
            this.currentProductInPopup.product_options = this.currentProductInPopup.categories
            this.currentProductInPopup.in_edit = true
            this.currentProductInPopup.image_url = []
            this.currentProductInPopup.image_url[0] = {'url': this.currentProductInPopup.image}
            if (this.currentProductInPopup.product_options.length) {
              for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {
                this.currentProductInPopup.product_options[i].values = this.currentProductInPopup.product_options[i].options
                this.currentProductInPopup.product_options[i].name = this.currentProductInPopup.product_options[i].title
                this.currentProductInPopup.product_options[i].min_no = this.currentProductInPopup.product_options[i].min
                this.currentProductInPopup.product_options[i].max_no = this.currentProductInPopup.product_options[i].max
                if (this.currentProductInPopup.product_options[i].values.length) {
                  for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                    this.currentProductInPopup.product_options[i].values[j].name = this.currentProductInPopup.product_options[i].values[j].name
                    if (this.currentProductInPopup.product_options[i].type === 'radio') {
                      if (this.currentProductInPopup.product_options[i].values[j].checked) {
                        this.currentProductInPopup.product_options[i].checked = this.currentProductInPopup.product_options[i].values[j].id
                      }
                    }
                  }
                }
              }
            }
          }
          if (this.currentProductInPopup.product_options && this.currentProductInPopup.product_options.length) {
            for (i = this.currentProductInPopup.product_options.length - 1; i >= 0; i--) {

              // add image and show_type_kiosk from company_option
              if (!this.currentProductInPopup.product_options[i].show_type_kiosk && this.currentProductInPopup.product_options[i].company_option) {
                this.currentProductInPopup.product_options[i].show_type_kiosk = this.currentProductInPopup.product_options[i].company_option.show_type_kiosk
                this.currentProductInPopup.product_options[i].image = this.currentProductInPopup.product_options[i].company_option.image
                if (this.currentProductInPopup.product_options[i].show_type_kiosk === 'steps') {
                  this.optionsInSteps = true

                  // fetchAndSetImage
                  if (
                      this.currentProductInPopup.product_options[i].image && 
                      this.currentProductInPopup.product_options[i].image != '' &&
                      this.currentProductInPopup.product_options[i].image.indexOf('placeholder') <= -1
                      ) {
                    this.fetchAndSetImage(this.currentProductInPopup.product_options[i].image)
                  }
                  for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                    if (
                        this.currentProductInPopup.product_options[i].values[j].image && 
                        this.currentProductInPopup.product_options[i].values[j].image != '' &&
                        this.currentProductInPopup.product_options[i].values[j].image.indexOf('placeholder') <= -1
                        ) {
                      this.fetchAndSetImage(this.currentProductInPopup.product_options[i].values[j].image)
                    }
                  }
                  // end fetchAndSetImage
                }
              }

              if (this.currentProductInPopup.product_options[i].required) {
                this.addToCartDisabled = true
                if (this.currentProductInPopup.use_price_to_show) {
                  if (this.currentProductInPopup.product_options[i].type == 'radio') {
                    this.currentProductInPopup.product_options[i].checked = this.currentProductInPopup.product_options[i].values[0].id
                  } else if (this.currentProductInPopup.product_options[i].type == 'checkbox' && !edit) {
                    this.currentProductInPopup.product_options[i].values[0].checked = this.currentProductInPopup.product_options[i].values[0].id
                  }
                  this.updateCategories();
                }
              }
              if (this.currentProductInPopup.product_options[i].values.length) {
                if (this.currentProductInPopup.product_options[i].values.length == 1 && this.currentProductInPopup.product_options[i].required) {
                  if (this.currentProductInPopup.product_options[i].type == 'radio') {
                    this.currentProductInPopup.product_options[i].checked = this.currentProductInPopup.product_options[i].values[0].id
                  } else if (this.currentProductInPopup.product_options[i].type == 'checkbox') {
                    this.currentProductInPopup.product_options[i].values[0].checked = this.currentProductInPopup.product_options[i].values[0].id
                  }
                  this.updateCategories();
                }
                // for (var j = this.currentProductInPopup.product_options[i].values.length - 1; j >= 0; j--) {
                // }
              }
            }
          }
          // this.updateCategories()
          // this.$modal.show('productModal')
          if (!noModal) {
            this.soldWithCategory = null
            this.soldWith(this.currentProductInPopup.id)
            this.showProductModal = true
          }
        }
        if (callback) {callback()}
      })
    },
    closeClientModal (key = true) {
      this.showClientModal = false
      window.removeEventListener('keyup', this.handleKeyUpClientModal)
      if (key) {
        this.definKeyboard()
      }
    },
    payNew () {
      if (this.json.type == 'Kiosk' && (this.use_smso || this.loyalty_in_use) ) {
        // this.activeKeyboard = true
        this.showClientModal = true
        window.addEventListener('keyup', this.handleKeyUpClientModal)
        // this.definKeyboard()

        this.activeKeyboardClient = true
        this.definKeyboardClient()

      } else {
        this.payNew2()
      }
    },
    validateAndContinueToPay () {
      if (!this.new_client && !this.client && this.phone_to_send != '') {
        this.searchForClient()
      } else {
        this.payNew2()
      }
    },
    payNew2 () {
      if (this.json.type == 'Kiosk') {
        this.activeKeyboard = false
        this.closeClientModal()

        setTimeout(() => { // for animation
          this.showPaymentModal = true
        }, 100)
        this.showCartModal = false
      } else {
        this.showPaymentModal = true
      }

      this.getPaymentProfile()
      this.onePaymentAllreadyPicked = false
      
      this.qr_code = null

      if (this.use_pager && this.pager == '') {
        this.disablePaymentClass = 'disabled';
        this.openPagerModal()
      }
    },
    verifyOrUpdateCart () { // for multiple users
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'product_validation',
        products_need_deleted: true,
        add_order: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
        }
        if (response.data.errors && response.data.errors.close) {
          this.restart()
        }
      })
    },
    unfreezeOrder () {
      if (this.onePaymentAllreadyPicked) return 0;
      this.onePaymentAllreadyPicked = true
      setTimeout(() => {
        this.onePaymentAllreadyPicked = false
      }, 500)
      if (this.json.type != 'Kiosk') {
        // this.freezeOrder (false, ()=>{
          this.showPaymentModal = false
        // });
      } else {
        this.showPaymentModal = false
      }
    },
    freezeOrder (freezStatus=true, callback) { // IS NOT IN USE
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'freeze_order',
        freeze_order: freezStatus,
        products_need_deleted: true,
        add_order: true,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      this.apiRequest('/update-cart', 'PUT', data, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          this.cart = response.data.data
          this.modificationsInCart()
          if (callback) {callback()}
        }
      })
    },
    orderNow (method) {
      let order_email = null
      let cls = null
      let $btnElement = null

      this.selectedPaymentMethod = method;

      if (this.onePaymentAllreadyPicked) return 0;
      this.onePaymentAllreadyPicked = true

      if (this.disablePaymentClass == 'disabled') {
        return 0;
      }

      if (this.email_to_send != '') {
        const emailInput = document.getElementById('email_to_send');
        if (emailInput.checkValidity()) {
          order_email = this.email_to_send
        } else {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.emailError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false
          return 0;
        }
      }

      if (method === 'card_pos') {
        cls = 'load_card_pos'
      }
      if (this.json.type == 'Kiosk') {
        if (method === 'qr') {
          cls = 'load_k_qr'
        }
        if (method === 'cash') {
          cls = 'load_k_cash'
        }
        if (method === 'cashMachine') {
          cls = 'load_cashMachine'
        }
        if (method === 'pos') {
          cls = 'load_k_pos'
        }
      } else {
        if (method === 'card') {
          cls = 'load_card'
        }
        if (method === 'cash') {
          cls = 'load_cash'
        }
        if (method === 'pos') {
          cls = 'load_pos'
        }
        if (method === 'free') {
          cls = 'load_free'
        }
      }
      $btnElement = document.querySelector('.'+cls)
      $btnElement.classList.add('loading')

      let errors = 0
      if (!errors) {
        var data2 = {
          token: this.token,
          company_id: this.json.company_id,
          table: this.json,
          action: 'product_validation',
          products_need_deleted: true,
          add_order: true,
          shopping_cart_id: this.cart.shopping_cart_id
        }
        if (order_email) {
          data2['order_email'] = order_email;
        }
        if (this.order_phone) {
          data2['order_phone'] = this.order_phone;
          data2['order_phone_country_code'] = this.order_phone_country_code;
        }
        this.apiRequest('/update-cart', 'PUT', data2, (response) => {
          if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.cart = response.data.data
            this.modificationsInCart()
            // if (response.data.some_products_deleted) {
            //   swal({
            //     title: '',
            //     text: this.$t('addOrder.errorProduct1'),
            //     type: 'error',
            //     showConfirmButton: true,
            //     target: document.getElementById('swal-template'),
            //     toast: true
            //   })
            // }
            // if (method == 'qr') {}
            setTimeout(() => {
              $btnElement.classList.remove('loading')
            }, 2000) // 2 sec
            switch (method) {
            case 'free':
                this.completeOrder('free')
                break;
              case 'cash':
                this.completeOrder('cash')
                break;
              case 'cashMachine':
                this.completeOrderWithCashMachine()
                break;
              case 'pos':
                this.completeOrder('pos')
                break;
              case 'qr':
                this.completeOrder('qr_pay')
                break;
              case 'card':
                this.completeOrderWithCard()
                break;
              case 'card_pos':
                if (this.DBfiscalNetWithPos) {
                  this.completeOrderWithFiscalNetPos()
                } else {
                  this.completeOrderWithPos()
                }
                break;
              default:
                console.log('New Method');
            }
          }
          if (response.data.errors && response.data.errors.close) {
            this.restart()
          }
        })
      }
      setTimeout(() => {
        this.selectedPaymentMethod = '';
      }, 3000);
    },
    completeOrderWithCashMachine () {
      this.insertedMoneyInCashMachine = 0
      this.socket.emit('start_pay', this.cart.myCart.total_cart_price * 100)
      this.showCashMachineModal = true
      this.customMsgCashMachine = null
    },
    completeOrderWithPos () {
      this.showPosModal = true
      let url = 'transaction?amount=' + this.cart.myCart.total_cart_price;
      this.localRequest(url, 'GET', {
        'pos': JSON.stringify(this.DBpos)
        }, (response) => {
        if (response.data.status) {
          this.completeOrder('card_pos', response.data.extraInfo);
        } else {
          // error
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.posGeneralError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false;
        }
        this.showPosModal = false
      })
    },
    completeOrderWithFiscalNetPos () {
      this.showPosModal = true

      let totalToSend = this.cart.myCart.total_cart_price
      totalToSend = totalToSend.toFixed(2)
      totalToSend = totalToSend.replace(',', '')
      totalToSend = parseInt(totalToSend.replace('.', ''))

      this.localRequestFiscalNet('/api/Receipt', 'POST', '"POS^'+totalToSend+'"', (response) => {
            
        if (response.data && response.data.ReceiptStatus) {
          this.completeOrder('card_pos', response.data.ReceiptInfo);
        } else {
          // error
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.posGeneralError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false;
        }
        this.showPosModal = false
      })
      // let url = 'transaction?amount=' + this.cart.myCart.total_cart_price;
      // this.localRequest(url, 'GET', {
      //   'pos': JSON.stringify(this.DBpos)
      //   }, (response) => {
      //   if (response.data.status) {
      //     this.completeOrder('card_pos', response.data.extraInfo);
      //   } else {
      //     // error
      //     let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      //     Swal.fire({
      //       title: this.$t('addOrder.posGeneralError'),
      //       target: document.getElementById('swal-template'),
      //       customClass: {
      //         container: className,
      //       }
      //     });
      //     this.onePaymentAllreadyPicked = false;
      //   }
      //   this.showPosModal = false
      // })
    },
    printOrder (orderNr, date, printContent=null, printTotal=null) {
      if (this.DBprinter) {
        let url = 'print?id=' + orderNr;
        let data = {
          'date': date,
          'company': JSON.stringify({
            'company_id': this.json.company_id,
            'kiosk_name': this.json.type + ' ' + this.json.number
          }),
          'content': JSON.stringify(printContent),
          'totals': JSON.stringify(printTotal),
          'printer': JSON.stringify(this.DBprinter)
        };
        this.localRequest(url, 'GET', data, (response) => {
          if (response.data.status) {
            console.log('Print Done');
          } else {
            console.log('Print Error');
          }
        })
      }
    },
    completeOrderWithCard () {
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        without_qr: 1,
        with_expiration: 3, // number of min
        redirect_url: this.qr_link,
        location_token: this.json.location_token,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      if (this.email_to_send != '') {
        const emailInput = document.getElementById('email_to_send');
        if (emailInput.checkValidity()) {
            data['email'] = this.email_to_send
        } else {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.emailError'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          });
          this.onePaymentAllreadyPicked = false
          return 0;
        }
      }
      this.formloadCounter = 0
      this.apiRequest('/get-qr-pay-link', 'GET', data, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (1) { // somethig in the future
            this.onePaymentAllreadyPicked = false
            window.location.href = response.data.data.html
          } else {
            this.showIframeModal = true;
            this.paymentLinkForIframe = response.data.data.html;

            const paymentFrame = document.getElementById('paymentFrame');
            window.addEventListener('message', message => {
              let s1 = message.origin.replace("https://", "").replace("/", "");
              let s2 = window.API_HOST.replace("https://", "").replace("/", "");
                if (s1 == s2) {
                  if (message.data == 'ok') {
                    this.showIframeModal = false;
                    this.paymentLinkForIframe = '';
                    this.completeOrder('card')
                  } else {
                    this.showIframeModal = false;
                    let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
                    Swal.fire({
                      title: this.$t('addOrder.euPlatesc_' + message.data),
                      target: document.getElementById('swal-template'),
                      customClass: {
                        container: className,
                      }
                    });
                    this.onePaymentAllreadyPicked = false
                  }
                }
            });
          }

        }
      })
    },
    completeOrder (payMethod, extraInfo = null) {
      this.qr_code = null
      // this.loadingCompleteOrder = true
      let oldOrderId = this.cart.order_id
      let orderForm = this.json.type + ' ' + this.json.zone + ' ' + this.json.number;
      if (this.packingMethod) {
        orderForm = orderForm + ' (' + this.$t('addOrder.' + this.packingMethod) + ')';
      }
      var data2 = {
        token: this.token,
        company_id: this.json.company_id,
        action: 'complete_order',
        products_need_deleted: true,
        add_order: true,
        self_ordering: true,
        order_from: orderForm,
        location_token: this.json.location_token,
        // chosen_hour: this.selectedHour,
        // chosen_date: this.selectedDate,
        shopping_cart_id: this.cart.shopping_cart_id,
        payment_type: payMethod,
        packing_method: this.packingMethod,
        transaction_response: extraInfo,
        cui: this.cui,
        pager: this.pager,
        comments: this.orderComments,
      }
      if (this.client && this.client.id) {
        data2.for_user = this.client.id
      }
      console.log(data2)
      this.apiRequest('/update-cart', 'PUT', data2, (response) => {
        this.onePaymentAllreadyPicked = false
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (payMethod == 'qr_pay') {
            var data3 = {
              token: this.token,
              company_id: this.json.company_id,
              location_token: this.json.location_token,
              shopping_cart_id: this.cart.shopping_cart_id
            }
            this.apiRequest('/get-qr-pay-link', 'GET', data3, (response) => {
              if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
                this.qr_code = response.data.data.qr_code
                this.checkIfPaymentIsComplete()
                this.startCountdown()
              }
            })
          } else if (payMethod == 'card_pos' && this.DBfiscal && !this.DBfiscalNet) {
            this.printFiscalAndFinish(response.data.data, payMethod);
          } else if (this.DBfiscalNet) {
            this.printFiscalNetAndFinish(response.data.data, payMethod);
          } else {
            let orderNumber = response.data.data.number
            if (response.data.data.posnet_order_id) {
              orderNumber = response.data.data.posnet_order_id
            }
            this.finishOrder(orderNumber, payMethod);
          }
        } else {
          this.restart()
        }
      })
    },
    printFiscalAndFinish (order, payMethod) {
      if (
          (payMethod == 'cash' && this.kiosk_is_using_fiscal_receipt_for_cash) ||
          payMethod != 'cash'
      ) {
        var data = {
          token: this.token,
          company_id: this.json.company_id
        }
        this.apiRequest('/noauth/print-fiscal/' + order.order_id + '/' + this.json.id, 'GET', data, (response) => {
          if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.localRequest('/fiscal_print', 'GET', {
                'print': response.data.data,
                'fiscal': JSON.stringify(this.DBfiscal)
              }, (response) => {
              let orderNumber = order.number
              if (order.posnet_order_id) {
                orderNumber = order.posnet_order_id
              }
              this.finishOrder(orderNumber, payMethod)
            })
          }
        })
      } else {
        this.finishOrder(order.number, payMethod)
      }
    },
    printFiscalNetAndFinish (order, payMethod) {
      if (
          (payMethod == 'cash' && this.kiosk_is_using_fiscal_receipt_for_cash) ||
          payMethod != 'cash'
      ) {

        let pay_method = 1 // cash
        if (payMethod == 'card_pos') {
          pay_method = 2 // card
        }
        var data = {
          token: this.token,
          pay_method: pay_method,
          company_id: this.json.company_id
        }
        if (this.cui != '') {
          data['cui'] = this.cui
        }
        this.apiRequest('/noauth/print-fiscal-net/' + order.order_id + '/' + this.json.id, 'GET', data, (response) => {
          if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.localRequestFiscalNet('/api/Receipt', 'POST', response.data.data, (responseFiscalNet) => {
              // console.log(response.data);
              // if (response.data && response.data.ErrorCode == '') {
              data.receipt_number = responseFiscalNet.data
              let orderNumber = order.number
              if (order.posnet_order_id) {
                orderNumber = order.posnet_order_id
              }
              this.finishOrder(orderNumber, payMethod)
              this.apiRequest('/noauth/print-fiscal-net-answer/' + order.order_id, 'POST', data, (responseFiscalNetAnswer) => {
                //silence
              })
              // }
            })
          }
        })
      } else {
        this.finishOrder(order.number, payMethod)
      }
    },
    finishOrder (orderNr, payMethod) {
      this.showLoaderCompleteCashMachine = false
      this.showCashMachineModal = false
      if (this.json.type == 'Kiosk') {
        let created_at = this.cart.created_at;
        let content = [];
        for (var i = 0; i < this.cart.myCart.products.length; i++) {
          content.push({
            name: this.cart.myCart.products[i].name,
            quantity: this.cart.myCart.products[i].quantity,
            price: this.cart.myCart.products[i].price + ' ' + this.currency_symbol,
          });
        }
        let totals = [];
        // totals.push({
        //   name: 'Subtotal',
        //   price: this.cart.myCart.totals_subtotals + ' ' + this.currency_symbol,
        // });
        for (var i = 0; i < this.cart.order_totals.length; i++) {
          if (this.cart.order_totals[i].use && this.cart.order_totals[i].value > 0) {
            totals.push({
              name: this.cart.order_totals[i].name,
              price: this.cart.order_totals[i].value + ' ' + this.currency_symbol,
            });
          }
        }
        totals.push({
          name: 'Total',
          price: this.cart.myCart.total_cart_price + ' ' + this.currency_symbol,
        });
        this.cart = null
        // this.loadingCompleteOrder = false
        this.showCompleteModal = true
        this.finishOrderNr = orderNr
        this.printOrder(orderNr, created_at, content, totals)
        clearTimeout(this.timeoutRestartFinishOrder)
        this.timeoutRestartFinishOrder = setTimeout(() => {
          this.restart()
        }, 5000) // 5 sec
      } else {
        if (this.json.company_id == 39) {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';

          // let $orderTxt = "<p style='margin: 0;'>Comanda: " + orderNr + "</p>"
          let $orderTxt = "<h2>Pentru plată și confirmarea comenzii te rugăm să prezinți colegilor de la casă acest mesaj</h2>"
          $orderTxt += "<p style='margin: 0; font-size: 18px;'>" + this.json.type + " " + this.json.number + "</p>"
          if (payMethod == 'cash') {
            $orderTxt += "<p style='margin: 0; font-size: 18px;'>PLATA CASH</p>"
          } else if (payMethod == 'pos') {
            $orderTxt += "<p style='margin: 0; font-size: 18px;'>PLATA POS</p>"
          }
          $orderTxt += "<p style='margin: 0; font-size: 18px;'>" + this.cart.myCart.total_cart_price + ' ' + this.currency_symbol + "</p>"

          Swal.fire({
            icon: 'success',
            title: 'Ești aproape gata!',
            html: $orderTxt,
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          }).then( (result) => {
            this.restart()
            // window.location.href = "https://www.taptasty.com/";
            return 0;
          })
        } else if (this.json.company_id == 125 || this.json.company_id == 208) {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';

          // let $orderTxt = "<p style='margin: 0;'>Comanda: " + orderNr + "</p>"
          let $orderTxt = "<h2>Comanda ta a fost plasată cu succes!</h2>"
          $orderTxt += "<h2>Urmareste statusul pe ecran si vino sa ridici comanda cand este gata!</h2>"
          $orderTxt += "<h2>" + this.json.type + " " + this.json.number + "</h2>"
          $orderTxt += "<p style='margin: 0; font-size: 18px;'>" + this.cart.myCart.total_cart_price + ' ' + this.currency_symbol + "</p>"

          Swal.fire({
            icon: 'success',
            title: 'Comanda ' + orderNr,
            html: $orderTxt,
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          }).then( (result) => {
            this.restart()
            // window.location.href = "https://www.taptasty.com/";
            return 0;
          })
        } else {
          let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          Swal.fire({
            title: this.$t('addOrder.finishOrderMsg'),
            target: document.getElementById('swal-template'),
            customClass: {
              container: className,
            }
          }).then( (result) => {
            this.restart()
            // window.location.href = "https://www.taptasty.com/";
            return 0;
          })
        }
      }
    },
    checkIfPaymentIsComplete () {
      let stopTimeout = false
      var data = {
        token: this.token,
        company_id: this.json.company_id,
        shopping_cart_id: this.cart.shopping_cart_id
      }
      this.apiRequest('/check-if-qr-payment-complete', 'GET', data, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data.data.payed) {
            this.stopTimeout = true
            this.finishOrder(response.data.data.number)
          }
        }
        clearTimeout(this.checkIfPaymentIsCompleteTimeout)
        if (this.countdown <= 0) {
          this.restart();
          return 0;
        }
        if (!stopTimeout) {
          this.checkIfPaymentIsCompleteTimeout = setTimeout(() => {
            this.checkIfPaymentIsComplete()
          }, 5000)
        }
      })
    },
    startCountdown () {
      this.countdown = 240; // 4 mins
      this.countDown()
    },
    countDown () {
      clearTimeout(this.countDownTimeout)
      this.countDownTimeout = setTimeout(() => {
        this.countDown()
      }, 1000)
      if (this.countdown > 0) {
        this.countdown--
      } else {
        this.restart()
      }
    },
    goFullScreen () {
      var element = document.querySelector('html')
      this.requestFullScreen(element)
      // if (this.isFullScreen) {
      //   document.exitFullscreen()
      //   this.isFullScreen = false
      // } else {
      //   this.isFullScreen = true
      //   this.requestFullScreen(element)
      // }
    },
    requestFullScreen (element) {
      // Supports most browsers and their versions.
      var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
      if (requestMethod) { // Native full screen.
        requestMethod.call(element)
      } else if (typeof window.ActiveXObject !== 'undefined') { // Older IE.
        var wscript = new ActiveXObject('WScript.Shell')
        if (wscript !== null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    goBackToPickMethod () {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.resetQuestion'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: true,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.restart()
        }
      })
    },
    refrashPage (callbackIfNotReloading) {
      var dd = {
        token: this.token,
        id: this.json.id,
        company_id: this.json.company_id,
        location_token: this.json.location_token,
      }
      this.apiRequest('/self-ordering-refrash', 'GET', dd, (response) => {
        if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
          if (response.data.data.refresh) {
            location.reload();
            return 0;
          }
        }
        callbackIfNotReloading();
      })
    },
    ckeckIfPosIsOnline () {
      if ((this.DBpos && (!this.DBfiscalNetWithPos))) {
        this.localRequest('/isOnline', 'GET', {
              'pos': JSON.stringify(this.DBpos)
            }, (response) => {
            
          if (response.data.resp == 'isOnline') {
            this.posPaymentEnabled = true
          }else {
            this.posPaymentEnabled = false
          }
        })
      } else if (this.DBfiscalNetWithPos && !this.DBfiscalNet) {
        this.posPaymentEnabled = true
      } else {
        this.posPaymentEnabled = false
      }
    },
    ckeckIfFiscalIsOnline () {
      if (this.DBfiscalNet) {
        // this.localRequestFiscalNet('/api/Receipt', 'POST', '"MD^Is^Online",', (response) => {
        //   if (response && response.data && response.data.ErrorCode == '0') {
            this.showSettings = true
            if (this.DBfiscalNetWithPos) {
              this.posPaymentEnabled = true
            }
          // }
        // })
      } else if (this.DBfiscal) {
        this.localRequest('/isOnline', 'GET', {
              'fiscal': JSON.stringify(this.DBfiscal)
            }, (response) => {
            
          if (response.data.showSettings) {
            this.showSettings = true
          }
          if (response.data.resp == 'isOnline') {
            this.posPaymentEnabled = true
          }else {
            this.posPaymentEnabled = false
          }
        })
      }
    },
    successMsgIfCardPay (orderId) {
      if (this.json.company_id == 125 || this.json.company_id == 208) {
        var data = {
          token: this.token,
          fingerprint: this.fingerprint,
          company_id: this.json.company_id,
          id: orderId,
          method: 'self_ordering'
        }
        this.apiRequest('/get-cart-by-id', 'GET', data, (response) => {
          if (response.status === 200 && (Array.isArray(response.data.errors) && !response.data.errors.length)) {
            this.loader = false;
            let orderNr = response.data.data.number
            let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
            let $orderTxt = "<h2>Comanda ta a fost plasată cu succes!</h2>"
            $orderTxt += "<h2>Urmareste statusul pe ecran si vino sa ridici comanda cand este gata!</h2>"
            $orderTxt += "<h2>" + this.json.type + " " + this.json.number + "</h2>"
            // $orderTxt += "<p style='margin: 0; font-size: 18px;'>" + this.cart.myCart.total_cart_price + ' ' + this.currency_symbol + "</p>"

            Swal.fire({
              icon: 'success',
              title: 'Comanda ' + orderNr,
              html: $orderTxt,
              target: document.getElementById('swal-template'),
              customClass: {
                container: className,
              }
            }).then( (result) => {
              window.location.href = this.qr_link;
            })
          } else {
            window.location.href = this.qr_link;
          }
        })
      } else {      
        this.loader = false;
        let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
        Swal.fire({
          icon: 'success',
          title: this.$t('addOrder.finishOrderMsg'),
          target: document.getElementById('swal-template'),
          customClass: {
            container: className,
          }
        }).then( (result) => {
          window.location.href = this.qr_link;
          return 0;
        })
      }
    },
    errorMsgIfCardPay (errorTxt) {
      this.loader = false;
      Swal.fire({
        icon: 'error',
        title: errorTxt,
        text: this.$t('addOrder.errorFinishOrderMsg'),
        target: document.getElementById('swal-template'),
        customClass: {
          container: 'smallSwall errorPaymentSwall',
        }
      }).then( (result) => {
        window.location.href = this.qr_link;
        return 0;
      })
    },
    restart () {
      if (this.json.type == 'Kiosk') {
        this.packed = false
        this.showSplashScreenModal = true
      } else {
        this.loader = true
        this.showSplashScreenModal = true
      }

      this.showLoaderCompleteCashMachine = false
      this.showCashMachineModal = false
      this.client = null
      this.new_client = null
      this.onePaymentAllreadyPicked = false
      this.infoShown.permanentDisabled = false
      this.closeClientModal(false)
      this.showOptionModal = false
      this.showProductModal = false
      this.showCartModal = false
      this.showCouponModal = false
      this.showSoldWithModal = false
      this.soldWithCategory = null;
      this.showPaymentModal = false
      this.showCompleteModal = false
      this.showSettingsModal = false
      this.showPagerModal = false
      this.posPaymentEnabled = false
      this.countdown = 120
      this.insertedMoneyInCashMachine = 0
      this.cui = ''
      this.phone_to_send = ''
      this.order_phone = null
      this.pagerText = ''
      this.pager = ''
      this.searchText = ''
      this.orderComments = '',
      this.couponText = '',
      clearTimeout(this.sliderNextTimeout)
      clearTimeout(this.countDownTimeout)
      clearTimeout(this.activitiDetected)
      clearTimeout(this.timeoutRestartFinishOrder)
      if (!this.error) {
        this.getCurrentLocation((ask_to_empty_the_order)=> { // -> doThelogin
          if (!this.onCreatedAfterLoginFlag) {
            this.onCreatedAfterLogin()
          }
          // console.log(this.$route); // in v3
          let uri = window.location.search.substring(1); 
          let params = new URLSearchParams(uri);
          if (params.get("error") != null && this.json.type != 'Kiosk') {
            this.errorMsgIfCardPay(decodeURI(params.get("error")))
          } else if (params.get("success") != null && this.json.type != 'Kiosk') {
            this.successMsgIfCardPay(params.get("orderid"))
          } else {
            this.refrashPage(()=>{
              if (ask_to_empty_the_order && this.json.type != 'Kiosk') {
                this.loader = false;
                let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
                Swal.fire({
                  title: this.$t('addOrder.relogin'),
                  confirmButtonText: this.$t('addOrder.deleteOrder'),
                  cancelButtonText: this.$t('addOrder.couninueOrder'),
                  showCancelButton: true,
                  showCloseButton: true,
                  target: document.getElementById('swal-template'),
                  customClass: {
                    container: className,
                  }
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.continueRestart(true);
                  } else {
                    this.continueRestart();
                  }
                })
              } else {
                this.continueRestart();
              }
            })
          }
        })
      } else {
        this.loader = false
      }
    },
    continueRestart (withTableUsers = false) {
      clearTimeout(this.checkIfPaymentIsCompleteTimeout)
      if (this.json.type == 'Kiosk') {
        this.showSplashScreenModal = true
        this.packed = false
      }
      this.getBanner()
      if (this.json.type != 'Kiosk') {
        this.getTheCart(()=>{
          if (withTableUsers) {
            this.emptyCart(withTableUsers)
          }
          this.loader = false
        })
      } else {
        this.getTheCart(()=>{
          this.emptyCart()
          this.loader = false
          this.ckeckIfPosIsOnline()
          this.ckeckIfFiscalIsOnline()
        })
      }
      
      this.getProducts(null,null,null,null, ()=> {
        if (this.json.company_id == 39) {
          // tutorial
          var storedTutorial = localStorage['showTutorial_' + this.json.company_id];
          if (storedTutorial) {
            storedTutorial = JSON.parse(storedTutorial);
          }
          if (!storedTutorial || (storedTutorial && (storedTutorial.time + 86400 * 1000) <= Date.now() )) {
            this.showP9Modal = true
            let tutorial = {
              'show': 1,
              'time': Date.now(),
            }
            localStorage['showTutorial_' + this.json.company_id] = JSON.stringify(tutorial);
          }
          // let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
          // Swal.fire({
          //   title: 'Salut! Bine ai venit la Piata9!',
          //   target: document.getElementById('swal-template'),
          //   customClass: {
          //     container: className,
          //   }
          // });
        }

        if (this.json.type != 'Kiosk') {
          this.createCacheForMenu();
        }

        if (this.json.type == 'Kiosk') {
          this.definKeyboard()
        }
      })
      // document.querySelector(".input").addEventListener("input", event => {
      //   this.keyboard.setInput(event.target.value);
      //   // this.activeKeyboard = true
      // });
    },
    createCacheForMenu () {
      const givenDate = new Date(this.refresh_products_date + " GMT")
      if (window.cache_date <= givenDate) {
        console.log('ClearCache')
        window.appInstanceCache = {}

        let deleteRequest = indexedDB.deleteDatabase(this.databaseName);
        deleteRequest.onsuccess = function(event) {
          console.log('Database deleted successfully');
        };
        deleteRequest.onerror = function(event) {
          console.error('Error deleting database:', event.target.error);
        };
        deleteRequest.onblocked = function(event) {
          console.warn('Database deletion blocked:', event.target.error);
        };

        // localStorage['tapTable_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id] = JSON.stringify(window.appInstanceCache)
        window.cache_date = new Date()
        localStorage['tapTable_cache_date_' + this.json.company_id + '_' + this.json.type + '_' + this.json.id] = window.cache_date.toISOString()

        let timeTimeout = 0
        for (var i = 0; i < this.category.length; i++) {
          if (this.category[i]) {
            timeTimeout += 100
            this.getCatForCache(this.category[i].id, null, timeTimeout)
          }
        }
        timeTimeout = 0
        let CatId = null;
        let TopCatId = null;
        if (this.top_category.length) {
          for (var i = 0; i < this.top_category.length; i++) {
            for (var j = 0; j < this.top_category[i].categories.length; j++) {
              if (this.top_category[i].categories[j].id) {
                timeTimeout += 100
                this.getCatForCache(this.top_category[i].categories[j].id, this.top_category[i].id, timeTimeout)
              }
            }
          }
        }
        // console.log(catId);
      }
    },
    openAllProducts (productsFromRequest) {
      if (productsFromRequest.length) {
        let timeTimeout = 100
        for (var i = 0; i < productsFromRequest.length; i++) {
          if (productsFromRequest[i]) {
            timeTimeout += 100
            this.getProductsForCache(productsFromRequest[i], timeTimeout)
          }
        }
      }
    },
    getProductsForCache (product, timeTimeout) {
      setTimeout( () => {
        this.openProduct (product, null, null, null, true)
      }, timeTimeout)
    },
    getCatForCache (CatId, TopCatId, timeTimeout) {
      setTimeout( () => {
        this.getProducts(CatId, TopCatId, null,null, ()=> {}, true)
      }, timeTimeout)
    }
  }
}